import React from "react";
import "./AccessDenied.scss"; // Import the SCSS file
import avatarImage from "../Images/ProfessionalGirl.jpg"; // Update with the actual path

const UpgradePlan = () => {
  const handleButtonClick = () => {
    window.location.href = "https://www.ourdept.in"; // Navigate to the external page
  };

  return (
    <div className="access-denied">
      <img
        src={avatarImage}
        alt="Access Denied Avatar"
        className="bouncing-avatar"
      />
      <h1>Upgrade Plan</h1>
      <p>Please upgrade to use this feature!</p>
      <button className="upgrade-btn" onClick={handleButtonClick}>
        Go to OurDept.in
      </button>
    </div>
  );
};

export default UpgradePlan;
